/* hub-popup-cal-all 2026-10-01 */
/**
 * Wizard calendar / popup datetime / pretty-select (from flow.attach).
 * Called after state exists. Variants attach after this so helpers stay bound.
 */
(function (global) {
  'use strict';
  if (global.WorkshopBookingWizardFlowDatetime) return;
  global.WorkshopBookingWizardFlowDatetime = {
    attach: function (S) {
      if (!S) return;
      var wizardRoot = S.wizardRoot;
      var MONTHS = S.MONTHS;
      var bindTimeDdReposition = S.bindTimeDdReposition;
      var bookingRoot = S.bookingRoot;
      var buildDaysMap = S.buildDaysMap;
      var calDateKey = S.calDateKey;
      var calendarDowLabels = S.calendarDowLabels;
      var clearBookingUrlEventIdKeepVariant = S.clearBookingUrlEventIdKeepVariant;
      var clonePlainMap = S.clonePlainMap;
      var data = S.data;
      var ensureLivePoll = S.ensureLivePoll;
      var ensureLockedVariantFromUrlOrSlot = S.ensureLockedVariantFromUrlOrSlot;
      var ensureTimeDdPortal = S.ensureTimeDdPortal;
      var eventsToSlots = S.eventsToSlots;
      var formatBookingSubLabel = S.formatBookingSubLabel;
      var formatCalDateBtn = S.formatCalDateBtn;
      var formatPopupDateLabel = S.formatPopupDateLabel;
      var formatPopupMonthLabel = S.formatPopupMonthLabel;
      var formatPopupSessionDateLabel = S.formatPopupSessionDateLabel;
      var formatPopupSessionTimeLabel = S.formatPopupSessionTimeLabel;
      var uniquePopupMonthKeys = S.uniquePopupMonthKeys;
      var dateKeysForMonth = S.dateKeysForMonth;
      var pickFirst = S.pickFirst;
      var ymKeyFromDateKey = S.ymKeyFromDateKey;
      var formatSlotOptionText = S.formatSlotOptionText;
      var getCalTimeDdParts = S.getCalTimeDdParts;
      var isAddonVariantId = S.isAddonVariantId;
      var isMobileViewport = S.isMobileViewport;
      var isStoreVenue = S.isStoreVenue;
      var liveFlags = S.liveFlags;
      var peekVenueSession = S.peekVenueSession;
      var applySavedVenueSession = S.applySavedVenueSession;
      var positionTimeDdPanel = S.positionTimeDdPanel;
      var quietEnrichCurrentSlots = S.quietEnrichCurrentSlots;
      var rebindSelectedVenueCard = S.rebindSelectedVenueCard;
      var refreshLiveNow = S.refreshLiveNow;
      var resetTimeDdPanelStyle = S.resetTimeDdPanelStyle;
      var setBranch = S.setBranch;
      var slotBookable = S.slotBookable;
      var slotDateKey = S.slotDateKey;
      var slotHidden = S.slotHidden;
      var slotVisible = S.slotVisible;
      var state = S.state;
      var stepEl = S.stepEl;
      var sweepViewMonthLive = S.sweepViewMonthLive;
      var syncBookingUrlForDatetimeStep = S.syncBookingUrlForDatetimeStep;
      var syncBookingUrlForVenueStep = S.syncBookingUrlForVenueStep;
      var syncSelectedVenueEventsFromSlots = S.syncSelectedVenueEventsFromSlots;
      var syncSiblingWorkshopPromo = S.syncSiblingWorkshopPromo;
      var syncVenueKindAttr = S.syncVenueKindAttr;
      var toIsoDateKey = S.toIsoDateKey;
      var updateBranchTitles = S.updateBranchTitles;

      function findSlotBySyncKey(key) {
        return typeof S.findSlotBySyncKey === 'function' ? S.findSlotBySyncKey(key) : null;
      }
      function slotSyncKey(slot) {
        return typeof S.slotSyncKey === 'function' ? S.slotSyncKey(slot) : '';
      }
      function syncCapacityRing() {
        if (typeof S.syncCapacityRing === 'function') S.syncCapacityRing();
      }
      function syncAtcReminder() {
        if (typeof S.syncAtcReminder === 'function') S.syncAtcReminder();
      }
      function renderVariants() {
        if (typeof S.renderVariants === 'function') S.renderVariants();
      }
      function updateVariantStepUi() {
        if (typeof S.updateVariantStepUi === 'function') S.updateVariantStepUi();
      }
      function maxBookableQty() {
        return typeof S.maxBookableQty === 'function' ? S.maxBookableQty() : 0;
      }
      function showWizardNotice(msg) {
        if (typeof S.showWizardNotice === 'function') S.showWizardNotice(msg);
      }
      function clearWizardNotice() {
        if (typeof S.clearWizardNotice === 'function') S.clearWizardNotice();
      }
      function stampFocusedVariantWhenFromMain() {
        if (typeof S.stampFocusedVariantWhenFromMain === 'function') S.stampFocusedVariantWhenFromMain();
      }
      function previewWizardVariant(id, options) {
        if (typeof S.previewWizardVariant === 'function') S.previewWizardVariant(id, options);
      }
      function syncVariantsAfterSlotChange() {
        if (
          typeof S.refreshAllVariantRowsForSlot === 'function' &&
          S.refreshAllVariantRowsForSlot()
        ) {
          if (state.lockedVariantId) {
            previewWizardVariant(state.lockedVariantId, { scrollCarousel: false });
          }
          return;
        }
        renderVariants();
        if (state.lockedVariantId) previewWizardVariant(state.lockedVariantId);
      }
      function refreshOpenLightboxWhen() {
        if (typeof S.refreshOpenLightboxWhen === 'function') S.refreshOpenLightboxWhen();
      }

    var CAL_LOADING_COPY = 'AtelierHub UK is finding the best event days for you';
    var CAL_LOADING_SHOW_MS = 240;
    var calLoadingShowTimer = 0;

    function isCalTimeDdOpen() {
      var parts = getCalTimeDdParts(wizardRoot);
      return !!(parts && parts.dd && parts.dd.classList.contains('is-open'));
    }

    function softRefreshDatetimeDayButtons() {
      var step = stepEl('datetime');
      if (!step) return;
      var grid = step.querySelector('[data-wbw-cal-grid]');
      if (!grid) return;
      grid.querySelectorAll('[data-wbw-cal-day]').forEach(function (btn) {
        var key = btn.getAttribute('data-wbw-cal-day') || '';
        var info = state.daysWithEvents[key];
        btn.classList.toggle('wcf-cal-day--open', !info);
        btn.classList.toggle('wcf-cal-day--muted', !info);
        btn.classList.toggle('wcf-cal-day--has-event', !!info);
        btn.classList.toggle('wcf-cal-day--soldout-only', !!(info && !info.bookable));
        btn.classList.toggle('wcf-cal-day--selected', key === state.selectedDate);
        btn.disabled = !info;
      });
    }

    function syncCalTimeDdButtonLabel(step) {
      var parts = getCalTimeDdParts(wizardRoot);
      var select = step && step.querySelector('[data-wbw-time-select]');
      if (!parts || !parts.btn || !select) return;
      var selectedOpt = select.options[select.selectedIndex];
      var hasValue = !!select.value;
      var emptyLabel = 'Select a time';
      if (!hasValue && select.options[0] && !select.options[0].value) {
        emptyLabel = select.options[0].textContent || emptyLabel;
      }
      parts.btn.disabled = false;
      parts.btn.removeAttribute('disabled');
      parts.btn.textContent =
        hasValue && selectedOpt && selectedOpt.textContent ? selectedOpt.textContent : emptyLabel;
      parts.btn.classList.toggle('is-placeholder', !hasValue);
      syncCalTimeAwaitingCue(step);
    }

    function softRefreshDatetimeTimeUi() {
      var step = stepEl('datetime');
      if (!step) return;
      softRefreshDatetimeDayButtons();
      var daySlots = slotsForDate(state.selectedDate).filter(slotVisible);
      var wasOpen = isCalTimeDdOpen();
      patchCalTimeNativeSelect(step, daySlots);
      syncCalTimeDdButtonLabel(step);
      if (wasOpen) {
        patchCalTimeDdPanelInPlace();
        var parts = getCalTimeDdParts(wizardRoot);
        if (parts && parts.panel && parts.panel.hidden) {
          openCalTimeDd({ keepOpenStamp: true });
        } else if (parts) {
          positionTimeDdPanel(parts);
        }
      }
      var toBtn = step.querySelector('[data-wbw-action="to-variants"]');
      if (!state.selectedSlot) {
        if (toBtn) toBtn.disabled = true;
      } else if (!slotBookable(state.selectedSlot)) {
        if (toBtn) toBtn.disabled = true;
      } else if (toBtn) {
        toBtn.disabled = false;
      }
      syncCapacityRing();
      syncAtcReminder();
      syncDatetimeHasDate();
    }

    function applySlotToDatetimeStep(slot) {
      if (!slot) return;
      state.selectedDate = slotDateKey(slot);
      if (state.selectedDate) {
        var dp = state.selectedDate.split('-').map(Number);
        if (dp.length >= 2) state.viewMonth = new Date(dp[0], dp[1] - 1, 1);
      }
      state.selectedSlot = slot;
      setBranch('datetime');
      renderCalendar({ closeTimeDd: false, allowAutoSelectSingle: false });
      var step = stepEl('datetime');
      var select = step && step.querySelector('[data-wbw-time-select]');
      if (select && (slotSyncKey(slot) || slot.gid)) {
        select.value = slotSyncKey(slot) || String(slot.gid || '');
        onTimeSelectChange({ track: false });
      }
    }

    function clearCalLoadingTimer() {
      if (calLoadingShowTimer) {
        clearTimeout(calLoadingShowTimer);
        calLoadingShowTimer = 0;
      }
    }

    function paintCalLoadingOverlay(overlay, message, isError) {
      overlay.classList.toggle('is-error', !!isError);
      overlay.innerHTML = '';
      if (isError) {
        overlay.textContent = message || "Couldn't load dates. Try again.";
        return;
      }
      var inner = document.createElement('span');
      inner.className = 'wcf-cal-loading-overlay__inner';
      var pulse = document.createElement('span');
      pulse.className = 'wcf-cal-loading-overlay__pulse';
      pulse.setAttribute('aria-hidden', 'true');
      var copy = document.createElement('span');
      copy.className = 'wcf-cal-loading-overlay__copy';
      copy.textContent = message || CAL_LOADING_COPY;
      inner.appendChild(pulse);
      inner.appendChild(copy);
      overlay.appendChild(inner);
    }

    function setDatetimeCalLoading(isLoading, message) {
      var step = stepEl('datetime');
      if (!step) return;
      var block = step.querySelector('.wcf-cal-block');
      if (!block) return;
      var on = !!isLoading;
      var isError =
        !!message &&
        message !== CAL_LOADING_COPY &&
        message !== 'Loading dates\u2026';
      clearCalLoadingTimer();
      block.classList.toggle('is-cal-loading', on);
      block.setAttribute('aria-busy', on ? 'true' : 'false');
      var sheet = block.querySelector('.wcf-cal-sheet') || block;
      var overlay = sheet.querySelector('[data-wbw-cal-loading]');
      if (!on) {
        if (overlay) {
          overlay.hidden = true;
          overlay.classList.remove('is-error');
        }
        return;
      }
      function showOverlay() {
        calLoadingShowTimer = 0;
        if (!overlay) {
          overlay = document.createElement('div');
          overlay.className = 'wcf-cal-loading-overlay';
          overlay.setAttribute('data-wbw-cal-loading', '1');
          overlay.setAttribute('role', 'status');
          sheet.appendChild(overlay);
        }
        paintCalLoadingOverlay(overlay, isError ? message : CAL_LOADING_COPY, isError);
        overlay.hidden = false;
      }
      if (isError) showOverlay();
      else calLoadingShowTimer = setTimeout(showOverlay, CAL_LOADING_SHOW_MS);
    }

    function prefetchVenueCalendar(venue) {
      if (!venue || venue.has_events !== true) return;
      if (!bookingRoot || typeof bookingRoot.__wbEnsureVenueCalendar !== 'function') return;
      var view = state.viewMonth instanceof Date ? new Date(state.viewMonth.getTime()) : new Date();
      if (venue.next_date_key && /^\d{4}-\d{2}/.test(String(venue.next_date_key))) {
        var nd = String(venue.next_date_key);
        view = new Date(Number(nd.slice(0, 4)), Number(nd.slice(5, 7)) - 1, 1);
      }
      bookingRoot
        .__wbEnsureVenueCalendar(venue, view, { lookahead: 1, prefetch: true, abortPrevious: false })
        .catch(function () {});
    }

    function calendarGridMatchesViewMonth() {
      var step = stepEl('datetime');
      var btn = step && step.querySelector('[data-wbw-cal-grid] [data-wbw-cal-day]');
      if (!btn || !(state.viewMonth instanceof Date)) return false;
      var key = btn.getAttribute('data-wbw-cal-day') || '';
      var prefix =
        state.viewMonth.getFullYear() +
        '-' +
        String(state.viewMonth.getMonth() + 1).padStart(2, '0');
      return key.indexOf(prefix) === 0;
    }

    function paintSlotsOntoCalendar(slots, renderOpts) {
      state.slotList = Array.isArray(slots) ? slots : [];
      state.daysWithEvents = buildDaysMap(state.slotList);
      syncSelectedVenueEventsFromSlots(state.slotList);
      setDatetimeCalLoading(false);
      if (state._wbwForceCalRerender || !calendarGridMatchesViewMonth()) {
        state._wbwForceCalRerender = false;
        renderCalendar(
          renderOpts || { closeTimeDd: false, allowAutoSelectSingle: false }
        );
      } else {
        softRefreshDatetimeTimeUi();
      }
      ensureLivePoll();
    }

    function resetDatetimeControlsDom() {
      var calStep = stepEl('datetime');
      if (calStep) {
        var calTime = calStep.querySelector('[data-wbw-time-select]');
        if (calTime) {
          calTime.innerHTML = '<option value="">Select a time</option>';
          calTime.value = '';
        }
        var dateBtn = calStep.querySelector('[data-wbw-date-btn]');
        if (dateBtn) {
          dateBtn.textContent = 'Select a date';
          dateBtn.classList.add('is-empty');
        }
        var grid = calStep.querySelector('[data-wbw-cal-grid]');
        if (grid) {
          grid.querySelectorAll('[data-wbw-cal-day]').forEach(function (btn) {
            btn.classList.remove('wcf-cal-day--selected');
          });
        }
      }
      closeCalTimeDd();
      clearPillHost(popupMonthPillsEl());
      clearPillHost(popupDatePillsEl());
      clearPillHost(popupTimePillsEl());
      state.selectedPopupMonth = '';
      var dateSel = popupDateSelect();
      var timeSel = popupTimeSelect();
      if (dateSel) {
        dateSel.innerHTML = '<option value="">Select a date</option>';
        dateSel.value = '';
        syncPrettySelect(dateSel);
      }
      if (timeSel) {
        timeSel.innerHTML = '<option value="">Select a time</option>';
        timeSel.value = '';
        syncPrettySelect(timeSel);
      }
      wizardRoot.setAttribute('data-wbw-has-date', 'false');
    }

    function slotsForDate(dateKey) {
      var want = toIsoDateKey(dateKey) || String(dateKey || '').slice(0, 10);
      if (!want) return [];
      return (state.slotList || []).filter(function (s) {
        return slotDateKeyIso(s) === want;
      });
    }

    function applyDatetimeSelectionAfterSlots(opts) {
      opts = opts || {};
      var priorDate = opts.priorDate != null ? String(opts.priorDate || '') : String(state.selectedDate || '');
      var priorGid =
        opts.priorGid != null
          ? String(opts.priorGid || '')
          : state.selectedSlot && state.selectedSlot.gid
            ? String(state.selectedSlot.gid)
            : '';
      var priorSyncKey =
        opts.priorSyncKey != null
          ? String(opts.priorSyncKey || '')
          : state.selectedSlot
            ? slotSyncKey(state.selectedSlot)
            : '';
      var deepLinkSlot = opts.deepLinkSlot || null;
      var allowDeepLink = opts.allowDeepLink === true && !state._wbwUserPickedCalDate;

      state.daysWithEvents = buildDaysMap(state.slotList);

      if (allowDeepLink && deepLinkSlot && slotVisible(deepLinkSlot)) {
        state.selectedDate = slotDateKey(deepLinkSlot);
        state.selectedSlot = deepLinkSlot;
      } else if (priorDate && state.daysWithEvents[priorDate]) {
        state.selectedDate = priorDate;
        state.selectedSlot = null;
        if (priorGid || priorSyncKey) {
          var daySlots = slotsForDate(priorDate);
          for (var i = 0; i < daySlots.length; i++) {
            if (!slotVisible(daySlots[i])) continue;
            if (
              (priorGid && String(daySlots[i].gid || '') === priorGid) ||
              (priorSyncKey && slotSyncKey(daySlots[i]) === priorSyncKey)
            ) {
              state.selectedSlot = daySlots[i];
              break;
            }
          }
        }
      } else if (state._wbwUserPickedCalDate && priorDate) {
        /* User day missing from map — keep selection; do not snap to keys[0]. */
        state.selectedDate = priorDate;
        state.selectedSlot = null;
      } else {
        state.selectedDate = '';
        state.selectedSlot = null;
      }

      if (opts.syncViewMonth && state.selectedDate) {
        var parts = state.selectedDate.split('-').map(Number);
        if (parts.length >= 2) state.viewMonth = new Date(parts[0], parts[1] - 1, 1);
      }
    }

    function renderCalendar(opts) {
      opts = opts || {};
      var step = stepEl('datetime');
      if (!step) return;
      var y = state.viewMonth.getFullYear();
      var m = state.viewMonth.getMonth();
      var label = step.querySelector('[data-wbw-cal-month-label]');
      if (label) label.textContent = MONTHS[m] + ' ' + y;
      syncCalMonthNavLabels(step, y, m);

      var dowEl = step.querySelector('[data-wbw-cal-dow]');
      if (dowEl) {
        dowEl.innerHTML = calendarDowLabels()
          .map(function (d) {
            return '<span class="wcf-cal-dow">' + d + '</span>';
          })
          .join('');
      }

      var grid = step.querySelector('[data-wbw-cal-grid]');
      if (!grid) return;
      var first = new Date(y, m, 1);
      var startPad = first.getDay();
      var daysInMonth = new Date(y, m + 1, 0).getDate();
      var html = '';
      var i;
      for (i = 0; i < startPad; i++) html += '<span class="wcf-cal-day wcf-cal-day--empty"></span>';
      for (var d = 1; d <= daysInMonth; d++) {
        var key = calDateKey(y, m, d);
        var info = state.daysWithEvents[key];
        var cls = 'wcf-cal-day';
        if (!info) cls += ' wcf-cal-day--open wcf-cal-day--muted';
        else {
          cls += ' wcf-cal-day--has-event';
          if (!info.bookable) cls += ' wcf-cal-day--soldout-only';
        }
        if (state.selectedDate === key) cls += ' wcf-cal-day--selected';
        html +=
          '<span class="wcf-cal-day-wrap"><button type="button" class="' +
          cls +
          '" data-wbw-cal-day="' +
          key +
          '"' +
          (info ? '' : ' disabled') +
          '>' +
          d +
          '</button></span>';
      }
      grid.innerHTML = html;
      var dateBtn = step.querySelector('[data-wbw-date-btn]');
      if (dateBtn) {
        var keys = Object.keys(state.daysWithEvents || {}).sort();
        dateBtn.textContent = state.selectedDate
          ? formatCalDateBtn(state.selectedDate)
          : keys.length
            ? 'Select a date'
            : 'Select a date';
        dateBtn.classList.toggle('is-empty', !state.selectedDate);
      }
      renderTimeOptions(opts);
      syncDatetimeHasDate();
    }

    function syncCalMonthNavLabels(step, y, m) {
      var prevBtn = step && step.querySelector('[data-wbw-cal-prev]');
      var nextBtn = step && step.querySelector('[data-wbw-cal-next]');
      if (!prevBtn || !nextBtn) return;
      var pm = m === 0 ? 11 : m - 1;
      var py = m === 0 ? y - 1 : y;
      var nm = m === 11 ? 0 : m + 1;
      var ny = m === 11 ? y + 1 : y;
      prevBtn.textContent = MONTHS[pm];
      nextBtn.textContent = MONTHS[nm];
      prevBtn.setAttribute('aria-label', 'Previous month, ' + MONTHS[pm] + ' ' + py);
      nextBtn.setAttribute('aria-label', 'Next month, ' + MONTHS[nm] + ' ' + ny);
    }

    function syncDatetimeHasDate() {
      wizardRoot.setAttribute('data-wbw-has-date', state.selectedDate ? 'true' : 'false');
      var step = stepEl('datetime');
      if (!step) return;
      var sub = step.querySelector('[data-wbw-cal-sub]');
      if (sub) sub.textContent = 'Choose a highlighted date, then a time.';
      var picked = step.querySelector('[data-wbw-cal-picked]');
      if (picked) {
        picked.hidden = true;
        picked.textContent = '';
      }
    }

    function loadCalendarMonthForView() {
      if (!state.selectedVenue) {
        setDatetimeCalLoading(false);
        renderCalendar({ closeTimeDd: false, allowAutoSelectSingle: false });
        return Promise.resolve();
      }
      if (!bookingRoot || typeof bookingRoot.__wbEnsureVenueCalendar !== 'function') {
        return Promise.reject(new Error('venue calendar fetch unavailable'));
      }
      state._wbCalLoadSeq = (state._wbCalLoadSeq || 0) + 1;
      var loadSeq = state._wbCalLoadSeq;
      var hasLocal =
        Array.isArray(state.selectedVenue.events) && state.selectedVenue.events.length > 0;
      if (hasLocal) {
        state.slotList = eventsToSlots(state.selectedVenue.events || []);
        state.daysWithEvents = buildDaysMap(state.slotList);
      }
      renderCalendar({ closeTimeDd: false, allowAutoSelectSingle: false });
      setDatetimeCalLoading(!hasLocal);
      return bookingRoot
        .__wbEnsureVenueCalendar(state.selectedVenue, state.viewMonth, {
          lookahead: 0,
          prefetch: true,
          abortPrevious: false,
        })
        .then(function () {
          if (loadSeq !== state._wbCalLoadSeq || state.branch !== 'datetime') return;
          var paintedSlots = Array.isArray(state.slotList) ? state.slotList.slice() : [];
          var slots = eventsToSlots(state.selectedVenue.events || []);
          if (!slots.length) slots = paintedSlots;
          state.slotList = slots;
          applyDatetimeSelectionAfterSlots({
            priorDate: state.selectedDate,
            priorGid: state.selectedSlot && state.selectedSlot.gid,
            priorSyncKey: state.selectedSlot ? slotSyncKey(state.selectedSlot) : '',
            allowDeepLink: false,
            syncViewMonth: false,
          });
          paintSlotsOntoCalendar(slots, { closeTimeDd: false, allowAutoSelectSingle: false });
          state._wbLiveSince = '';
          sweepViewMonthLive();
          return quietEnrichCurrentSlots(
            function () {
              return loadSeq === state._wbCalLoadSeq;
            },
            { force: true }
          );
        })
        .catch(function (err) {
          if (loadSeq !== state._wbCalLoadSeq || state.branch !== 'datetime') return;
          if (err && err.name === 'AbortError') {
            setDatetimeCalLoading(false);
            return;
          }
          var msg =
            err && err.message === 'bad_request'
              ? 'Invalid date range. Try another month.'
              : "Couldn't load dates. Try again.";
          setDatetimeCalLoading(true, msg);
        });
    }

    var timeDdOpenedAtMs = 0;
    function closeCalTimeDd() {
      var parts = getCalTimeDdParts(wizardRoot);
      if (!parts) return;
      if (parts.panel) {
        parts.panel.hidden = true;
        parts.panel.setAttribute('hidden', '');
        resetTimeDdPanelStyle(parts.panel);
        parts.dd.appendChild(parts.panel);
      }
      if (parts.btn) parts.btn.setAttribute('aria-expanded', 'false');
      parts.dd.classList.remove('is-open');
    }

    function openCalTimeDd(opts) {
      opts = opts || {};
      var parts = getCalTimeDdParts(wizardRoot);
      if (!parts || !parts.panel || !parts.btn) return;
      bindTimeDdReposition(wizardRoot);
      ensureTimeDdPortal().appendChild(parts.panel);
      parts.panel.hidden = false;
      parts.panel.removeAttribute('hidden');
      parts.btn.setAttribute('aria-expanded', 'true');
      parts.dd.classList.add('is-open');
      /* Soft/background reopen must not reset the outside-click grace window. */
      if (!opts.keepOpenStamp) timeDdOpenedAtMs = Date.now();
      positionTimeDdPanel(parts);
      var selected = parts.panel.querySelector('.wcf-cal-time__dd-opt.is-selected');
      if (selected && typeof selected.scrollIntoView === 'function') {
        selected.scrollIntoView({ block: 'nearest' });
      }
    }

    function syncCalTimeAwaitingCue(step) {
      if (!step) return;
      var dd = step.querySelector('[data-wbw-cal-time-dd]');
      var calTime = step.querySelector('[data-wbw-cal-time]');
      if (dd) dd.classList.remove('is-awaiting-time');
      if (calTime) calTime.classList.remove('is-awaiting-time');
    }

    function syncCalTimeDdFromSelect(step) {
      var dd = step && step.querySelector('[data-wbw-cal-time-dd]');
      var select = step && step.querySelector('[data-wbw-time-select]');
      if (!dd || !select) return;

      var parts = getCalTimeDdParts(wizardRoot);
      if (!parts || parts.dd !== dd) return;
      var btn = parts.btn;
      var panel = parts.panel;
      if (!btn || !panel) return;

      btn.disabled = false;
      btn.removeAttribute('disabled');
      var selectedOpt = select.options[select.selectedIndex];
      var hasValue = !!select.value;
      var emptyLabel = 'Select a time';
      if (!hasValue && select.options[0] && !select.options[0].value) {
        emptyLabel = select.options[0].textContent || emptyLabel;
      }
      btn.textContent =
        hasValue && selectedOpt && selectedOpt.textContent
          ? selectedOpt.textContent
          : emptyLabel;
      btn.classList.toggle('is-placeholder', !hasValue);
      syncCalTimeAwaitingCue(step);

      panel.innerHTML = '';

      for (var i = 0; i < select.options.length; i++) {
        var opt = select.options[i];
        if (!opt.value) continue;
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'wcf-cal-time__dd-opt';
        item.setAttribute('role', 'option');
        item.setAttribute('data-gid', opt.value);
        item.textContent = opt.textContent;
        if (opt.selected) item.classList.add('is-selected');
        if (/sold out/i.test(opt.textContent)) item.classList.add('is-soldout');
        item.addEventListener('pointerdown', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var gid = ev.currentTarget.getAttribute('data-gid');
          if (!gid) return;
          select.value = gid;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          closeCalTimeDd();
        });
        item.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        });
        panel.appendChild(item);
      }
      if (!panel.querySelector('.wcf-cal-time__dd-opt')) {
        var empty = document.createElement('button');
        empty.type = 'button';
        empty.className = 'wcf-cal-time__dd-opt is-empty';
        empty.disabled = true;
        empty.textContent = emptyLabel;
        panel.appendChild(empty);
      }
      if (!panel.__wbwPanelClickStop) {
        panel.__wbwPanelClickStop = true;
        panel.addEventListener('click', function (ev) {
          ev.stopPropagation();
        });
        panel.addEventListener('mousedown', function (ev) {
          ev.stopPropagation();
        });
      }
    }

    function findSlotForTimeValue(gid) {
      var want = String(gid || '').trim();
      if (!want) return null;
      var found = findSlotBySyncKey(want);
      if (found) return found;
      var list = state.selectedDate ? slotsForDate(state.selectedDate) : state.slotList || [];
      for (var i = 0; i < list.length; i++) {
        var s = list[i];
        if (!s) continue;
        if (String(s.gid || '') === want || slotSyncKey(s) === want) return s;
      }
      return null;
    }

    function onTimeSelectChange(opts) {
      opts = opts || {};
      var trackUser = opts.track !== false;
      var step = stepEl('datetime');
      if (!step) return;
      var select = step.querySelector('[data-wbw-time-select]');
      var toBtn = step.querySelector('[data-wbw-action="to-variants"]');
      if (!select) return;

      var gid = String(select.value || '').trim();
      if (!gid) {
        state.selectedSlot = null;
        if (toBtn) toBtn.disabled = true;
        clearBookingUrlEventIdKeepVariant();
        syncCalTimeDdFromSelect(step);
        syncCapacityRing();
        syncAtcReminder();
        syncDatetimeHasDate();
        return;
      }

      var slot = findSlotForTimeValue(gid);
      if (!slot || !slotVisible(slot)) {
        state.selectedSlot = null;
        if (toBtn) toBtn.disabled = true;
        syncCalTimeDdFromSelect(step);
        syncCapacityRing();
        syncAtcReminder();
        syncDatetimeHasDate();
        return;
      }

      state.selectedSlot = slot;
      if (!slotBookable(slot)) {
        if (toBtn) toBtn.disabled = true;
      } else {
        if (toBtn) toBtn.disabled = false;
        syncWorkshopSelection(slot);
      }
      if (trackUser) {
        try {
          var wbwA = global.WorkshopBookingWizardAnalytics;
          if (wbwA && typeof wbwA.trackUser === 'function') {
            wbwA.trackUser('time', 'wbw_time_select', state, wizardRoot, S.data || {}, {
              wbw_source: opts.source || 'datetime_select',
            });
          } else if (wbwA && typeof wbwA.track === 'function') {
            if (typeof wbwA.mark === 'function') wbwA.mark('time');
            wbwA.track('wbw_time_select', state, wizardRoot, S.data || {}, {
              wbw_source: opts.source || 'datetime_select',
            });
          }
        } catch (_) {}
      }
      syncCalTimeDdFromSelect(step);
      syncCapacityRing();
      syncAtcReminder();
      syncDatetimeHasDate();
    }

    function patchCalTimeNativeSelect(step, daySlots) {
      var select = step && step.querySelector('[data-wbw-time-select]');
      if (!select) return;
      daySlots = daySlots || [];
      if (!state.selectedDate) {
        if (select.options.length !== 1 || select.options[0].value) {
          select.innerHTML = '<option value="">Select a time</option>';
        }
        return;
      }
      var byKey = Object.create(null);
      daySlots.forEach(function (slot) {
        var k = slotSyncKey(slot) || String(slot.gid || '');
        if (k) byKey[k] = slot;
      });
      var current = String(select.value || '');
      var still = false;
      var hasPlaceholder = false;
      Array.prototype.slice.call(select.options).forEach(function (opt) {
        if (!opt.value) {
          hasPlaceholder = true;
          opt.textContent = daySlots.length ? 'Select a time' : 'No sessions this day';
          return;
        }
        var slot = byKey[opt.value];
        if (!slot) {
          if (opt.parentNode) opt.parentNode.removeChild(opt);
          return;
        }
        opt.textContent = formatSlotOptionText(slot);
        if (opt.value === current) still = true;
        delete byKey[opt.value];
      });
      if (!hasPlaceholder) {
        var ph = document.createElement('option');
        ph.value = '';
        ph.textContent = daySlots.length ? 'Select a time' : 'No sessions this day';
        select.insertBefore(ph, select.firstChild);
      }
      Object.keys(byKey).forEach(function (k) {
        var slot = byKey[k];
        var opt = document.createElement('option');
        opt.value = k;
        opt.textContent = formatSlotOptionText(slot);
        select.appendChild(opt);
      });
      if (current && !still) select.value = '';
      else if (current) select.value = current;
      select.disabled = false;
    }

    function bindCalTimeDdOpt(item, select) {
      item.addEventListener('pointerdown', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var gid = ev.currentTarget.getAttribute('data-gid');
        if (!gid) return;
        select.value = gid;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        closeCalTimeDd();
      });
      item.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
      });
    }

    function patchCalTimeDdPanelInPlace() {
      var parts = getCalTimeDdParts(wizardRoot);
      var step = stepEl('datetime');
      var select = step && step.querySelector('[data-wbw-time-select]');
      if (!parts || !parts.panel || !select) return;
      var have = Object.create(null);
      parts.panel.querySelectorAll('[data-gid]').forEach(function (item) {
        var gid = item.getAttribute('data-gid') || '';
        var opt = null;
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === gid) {
            opt = select.options[i];
            break;
          }
        }
        if (!opt) {
          if (item.parentNode) item.parentNode.removeChild(item);
          return;
        }
        item.textContent = opt.textContent;
        item.classList.toggle('is-selected', !!opt.selected || select.value === gid);
        item.classList.toggle('is-soldout', /sold out/i.test(opt.textContent || ''));
        have[gid] = true;
      });
      for (var j = 0; j < select.options.length; j++) {
        var o = select.options[j];
        if (!o.value || have[o.value]) continue;
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'wcf-cal-time__dd-opt';
        item.setAttribute('role', 'option');
        item.setAttribute('data-gid', o.value);
        item.textContent = o.textContent;
        if (o.selected || select.value === o.value) item.classList.add('is-selected');
        if (/sold out/i.test(o.textContent || '')) item.classList.add('is-soldout');
        bindCalTimeDdOpt(item, select);
        parts.panel.appendChild(item);
      }
    }

    function renderCalTimeNativeSelect(step, daySlots, opts) {
      opts = opts || {};
      var select = step.querySelector('[data-wbw-time-select]');
      if (!select) return;

      if (!state.selectedDate) {
        select.disabled = false;
        select.innerHTML = '<option value="">Select a time</option>';
        return;
      }

      select.innerHTML = '';
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = daySlots.length ? 'Select a time' : 'No sessions this day';
      select.appendChild(placeholder);

      daySlots.forEach(function (slot) {
        var opt = document.createElement('option');
        opt.value = slotSyncKey(slot) || String(slot.gid || '');
        opt.textContent = formatSlotOptionText(slot);
        if (state.selectedSlot && slotSyncKey(state.selectedSlot) === opt.value) opt.selected = true;
        select.appendChild(opt);
      });

      select.disabled = false;

      /* Only auto-fill when that day has exactly one bookable time. */
      if (opts.allowAutoSelectSingle === true && !state.selectedSlot) {
        var bookableTimes = [];
        for (var si = 0; si < daySlots.length; si++) {
          if (slotBookable(daySlots[si])) bookableTimes.push(daySlots[si]);
        }
        if (bookableTimes.length === 1) {
          select.value = slotSyncKey(bookableTimes[0]) || String(bookableTimes[0].gid || '');
          onTimeSelectChange({ track: false });
        }
      }
    }

    function renderTimeOptions(opts) {
      opts = opts || {};
      var step = stepEl('datetime');
      if (!step) return;
      var hint = step.querySelector('[data-wbw-cal-time-hint]');
      var toBtn = step.querySelector('[data-wbw-action="to-variants"]');
      var daySlots = slotsForDate(state.selectedDate).filter(slotVisible);
      var hasBookableSlots = daySlots.some(slotBookable);
      var wasOpen = isCalTimeDdOpen();
      /* Default: background refreshes must NOT close an open time dropdown. */
      var shouldClose = opts.closeTimeDd === true;
      var allowAuto = opts.allowAutoSelectSingle === true;

      renderCalTimeNativeSelect(step, daySlots, { allowAutoSelectSingle: allowAuto });
      if (shouldClose) {
        syncCalTimeDdFromSelect(step);
        closeCalTimeDd();
      } else if (wasOpen) {
        syncCalTimeDdButtonLabel(step);
        var openParts = getCalTimeDdParts(wizardRoot);
        if (openParts && openParts.panel && openParts.panel.hidden) {
          openCalTimeDd({ keepOpenStamp: true });
        }
      } else {
        syncCalTimeDdFromSelect(step);
      }

      if (hint) {
        if (state.selectedDate && !daySlots.length) {
          hint.textContent = 'Pick another date with a bold number.';
          hint.hidden = false;
        } else if (state.selectedDate && daySlots.length && !hasBookableSlots) {
          hint.textContent = '';
          hint.hidden = true;
        } else {
          hint.textContent = '';
          hint.hidden = true;
        }
      }

      if (!state.selectedSlot) {
        if (toBtn) toBtn.disabled = true;
      } else if (!slotBookable(state.selectedSlot)) {
        if (toBtn) toBtn.disabled = true;
      } else if (toBtn) {
        toBtn.disabled = false;
      }
      syncCalTimeAwaitingCue(step);
      syncCapacityRing();
      syncAtcReminder();
    }

    function bindCalTimeControls() {
      var step = stepEl('datetime');
      if (!step) return;
      var select = step.querySelector('[data-wbw-time-select]');
      if (select && !select.__wbwTimeBound) {
        select.__wbwTimeBound = true;
        select.addEventListener('change', function () {
          onTimeSelectChange({ track: true, source: 'datetime_select' });
        });
      }

      var dd = step.querySelector('[data-wbw-cal-time-dd]');
      if (!dd || dd.__wbwDdBound) return;
      dd.__wbwDdBound = true;
      var btn = dd.querySelector('[data-wbw-cal-time-dd-btn]');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var parts = getCalTimeDdParts(wizardRoot);
        if (parts && parts.panel && !parts.panel.hidden) closeCalTimeDd();
        else openCalTimeDd();
      });

      if (!wizardRoot.__wbwCalTimeDdDocClose) {
        wizardRoot.__wbwCalTimeDdDocClose = true;
        document.addEventListener('click', function (e) {
          var parts = getCalTimeDdParts(wizardRoot);
          if (!parts || !parts.dd.classList.contains('is-open')) return;
          /* Same-click / immediate re-entry after open must not close the menu. */
          if (timeDdOpenedAtMs && Date.now() - timeDdOpenedAtMs < 200) return;
          if (e.target.closest('[data-wbw-cal-time-dd]')) return;
          if (e.target.closest('[data-wbw-time-dd-portal]')) return;
          closeCalTimeDd();
        });
      }
    }

    function shiftCalendarMonth(delta) {
      var next = Number(delta) || 0;
      if (!next) return;
      var step = stepEl('datetime');
      var days = step && step.querySelector('[data-wbw-cal-grid]');
      if (days && days.__wbwSliding) return;
      state.viewMonth = new Date(state.viewMonth.getFullYear(), state.viewMonth.getMonth() + next, 1);
      closeCalTimeDd();
      if (!days || isMobileViewport()) {
        loadCalendarMonthForView();
        return;
      }
      days.__wbwSliding = true;
      days.style.transition = 'transform 0.26s ease, opacity 0.2s ease';
      days.style.transform = 'translateX(' + (next > 0 ? '-32%' : '32%') + ')';
      days.style.opacity = '0';
      window.setTimeout(function () {
        loadCalendarMonthForView()
          .catch(function () {})
          .then(function () {
            var grid = step.querySelector('[data-wbw-cal-grid]');
            if (!grid) return;
            grid.__wbwSliding = true;
            grid.style.transition = 'none';
            grid.style.transform = 'translateX(' + (next > 0 ? '32%' : '-32%') + ')';
            grid.style.opacity = '0';
            void grid.offsetWidth;
            grid.style.transition = 'transform 0.26s ease, opacity 0.2s ease';
            grid.style.transform = 'translateX(0)';
            grid.style.opacity = '1';
            window.setTimeout(function () {
              grid.style.transition = '';
              grid.style.transform = '';
              grid.style.opacity = '';
              grid.__wbwSliding = false;
            }, 280);
          });
      }, 200);
    }

    function bindCalMonthSwipe() {
      var step = stepEl('datetime');
      if (!step) return;
      var block = step.querySelector('.wcf-cal-block--picker');
      if (!block || block.__wbwSwipeBound) return;
      block.__wbwSwipeBound = true;
      var startX = 0;
      var startY = 0;
      var tracking = false;
      var axis = '';

      block.addEventListener(
        'touchstart',
        function (e) {
          if (!isMobileViewport() || e.touches.length !== 1) return;
          if (e.target.closest('[data-wbw-cal-time-dd], [data-wbw-time-select]')) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          tracking = true;
          axis = '';
        },
        { passive: true }
      );

      block.addEventListener(
        'touchmove',
        function (e) {
          if (!tracking || e.touches.length !== 1) return;
          var dx = e.touches[0].clientX - startX;
          var dy = e.touches[0].clientY - startY;
          if (!axis && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
            axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          }
        },
        { passive: true }
      );

      block.addEventListener(
        'touchend',
        function (e) {
          if (!tracking) return;
          tracking = false;
          if (axis !== 'x' || !e.changedTouches || !e.changedTouches[0]) return;
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) < 48) return;
          state._wbwIgnoreCalTapUntil = Date.now() + 400;
          shiftCalendarMonth(dx < 0 ? 1 : -1);
        },
        { passive: true }
      );
    }

    function syncWorkshopSelection(slot) {
      if (!slot) return;
      var raw = slot._raw || {};
      var eventId = String(raw.id || raw.gid || slot.gid || '').trim();
      var eventHandle = String(raw.handle || slot.handle || '').trim();
      window.__WORKSHOP_SELECTION__ = {
        eventId: eventId,
        eventHandle: eventHandle,
        city: String(raw.city || '').trim(),
        state: String(raw.state || '').trim(),
        venue: String(raw.venue_name || raw.venue || (state.selectedVenue && state.selectedVenue.venue_name) || '').trim(),
        datetime: formatBookingSubLabel(slot),
      };
      try {
        document.dispatchEvent(new CustomEvent('wb:selection', { detail: window.__WORKSHOP_SELECTION__ }));
      } catch (_) {}
      syncBookingUrlForDatetimeStep(slot);
      window.__WB_INITIAL_EVENT_ID__ = null;
    }

    function startDatetimeStep() {
      rebindSelectedVenueCard();
      if (!state.selectedVenue) return Promise.resolve();
      if (!bookingRoot || typeof bookingRoot.__wbEnsureVenueCalendar !== 'function') {
        return Promise.reject(new Error('venue calendar fetch unavailable'));
      }
      if (!state.selectedVenue.venue_ref_id) {
        return Promise.reject(new Error('venue_ref_id missing'));
      }
      if (state.selectedVenue.has_events !== true) {
        return Promise.reject(new Error('venue has_events is not true'));
      }
      if (bookingRoot) bookingRoot.__wbWizardVenueChosen = true;
      /* Prevent search/list re-renders from re-triggering URL deep-link advance. */
      wizardRoot.__wbwUrlDeepLinkComplete = true;
      wizardRoot.__wbwUserReachedDatetime = true;
      state._wbCalLoadSeq = (state._wbCalLoadSeq || 0) + 1;
      var loadSeq = state._wbCalLoadSeq;
      var viewSeed = state.viewMonth instanceof Date ? state.viewMonth : new Date();
      if (
        state.selectedVenue.next_date_key &&
        /^\d{4}-\d{2}/.test(String(state.selectedVenue.next_date_key))
      ) {
        var nd = String(state.selectedVenue.next_date_key);
        viewSeed = new Date(Number(nd.slice(0, 4)), Number(nd.slice(5, 7)) - 1, 1);
      }
      state.viewMonth = viewSeed;

      state.flow = 'booking';
      wizardRoot.setAttribute('data-wbw-flow', 'booking');
      var savedSession = peekVenueSession(state.selectedVenue);
      state._wbwUserPickedCalDate = !!(savedSession && savedSession.userPickedCalDate);
      state.selectedDate = savedSession ? String(savedSession.selectedDate || '') : '';
      state.selectedSlot = null;
      state.variantWhen = savedSession ? clonePlainMap(savedSession.variantWhen) : {};
      state.variantQty = savedSession ? clonePlainMap(savedSession.variantQty) : {};
      if (savedSession && savedSession.focusedVariantId) {
        state.focusedVariantId = savedSession.focusedVariantId;
      }
      if (savedSession && savedSession.lockedVariantId) {
        state.lockedVariantId = savedSession.lockedVariantId;
      }
      state.lbEditVariant = '';
      state.lbApplyAll = null;
      state.lbAskApply = false;
      state._wbwForceCalRerender = true;
      if (savedSession && savedSession.viewMonth) {
        state.viewMonth = new Date(savedSession.viewMonth);
      }
      if (!savedSession || !savedSession.selectedDate) resetDatetimeControlsDom();
      updateBranchTitles();
      syncBookingUrlForVenueStep(state.selectedVenue);
      setBranch('datetime');
      /* Bookable venues: Connect waitlist panel under shell (wbSyncBelowWaitlistPanel). */

      function stillOnDatetimeIntent() {
        return loadSeq === state._wbCalLoadSeq && state.branch === 'datetime';
      }

      var hasLocal =
        Array.isArray(state.selectedVenue.events) && state.selectedVenue.events.length > 0;
      if (hasLocal) {
        state.slotList = eventsToSlots(state.selectedVenue.events || []);
        state.daysWithEvents = buildDaysMap(state.slotList);
        var localKeys = Object.keys(state.daysWithEvents).sort();
        if (localKeys.length && !(savedSession && savedSession.selectedDate)) {
          var lp = localKeys[0].split('-').map(Number);
          if (lp.length >= 2) state.viewMonth = new Date(lp[0], lp[1] - 1, 1);
        }
      } else {
        state.slotList = [];
        state.daysWithEvents = {};
      }
      renderCalendar({ allowAutoSelectSingle: false });
      setDatetimeCalLoading(!hasLocal);

      return bookingRoot
        .__wbEnsureVenueCalendar(state.selectedVenue, state.viewMonth, {
          lookahead: 1,
          prefetch: true,
          abortPrevious: false,
        })
        .then(function () {
          if (!stillOnDatetimeIntent()) return;
          rebindSelectedVenueCard();
          if (!state.selectedVenue) return;
          var baseSlots = eventsToSlots(state.selectedVenue.events || []);
          if (!baseSlots.length) {
            state.slotList = [];
            state.daysWithEvents = {};
            state.selectedDate = '';
            state.selectedSlot = null;
            setDatetimeCalLoading(false);
            renderCalendar({ closeTimeDd: true, allowAutoSelectSingle: false });
            ensureLivePoll();
            return state.slotList;
          }
          state.slotList = baseSlots;
          applySavedVenueSession(savedSession);
          paintSlotsOntoCalendar(baseSlots, {
            closeTimeDd: true,
            allowAutoSelectSingle: false,
          });
          if (state.selectedSlot) syncBookingUrlForDatetimeStep(state.selectedSlot);
          state._wbLiveSince = '';
          sweepViewMonthLive();
          return quietEnrichCurrentSlots(stillOnDatetimeIntent, { force: true });
        })
        .catch(function (err) {
          if (!stillOnDatetimeIntent()) return;
          if (err && err.name === 'AbortError') {
            setDatetimeCalLoading(false);
            return;
          }
          var msg =
            err && err.message === 'bad_request'
              ? 'Invalid date range. Try another month.'
              : "Couldn't load dates. Try again.";
          setDatetimeCalLoading(true, msg);
        });
    }

    function popupDateSelect() {
      return wizardRoot.querySelector('[data-wbw-popup-date]');
    }

    function popupTimeSelect() {
      return wizardRoot.querySelector('[data-wbw-popup-time]');
    }

    function popupDatetimePanel() {
      return wizardRoot.querySelector('[data-wbw-popup-datetime]');
    }

    function setPopupDatetimeHint(msg, isError) {
      var hint = wizardRoot.querySelector('[data-wbw-popup-datetime-hint]');
      if (!hint) return;
      if (!msg) {
        hint.hidden = true;
        hint.textContent = '';
        hint.classList.remove('is-error');
        return;
      }
      hint.hidden = false;
      hint.textContent = msg;
      hint.classList.toggle('is-error', !!isError);
    }

    function setPopupDatetimeLoading(on) {
      var panel = popupDatetimePanel();
      if (!panel) return;
      panel.classList.toggle('is-loading', !!on);
      panel.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    function slotDateKeyIso(slot) {
      if (!slot) return '';
      return (
        toIsoDateKey(slot.date_key) ||
        toIsoDateKey(slot.schema_start) ||
        toIsoDateKey(slot.starts_at) ||
        toIsoDateKey(slotDateKey(slot)) ||
        ''
      );
    }

    function uniquePopupDateKeys() {
      var map = Object.create(null);
      function add(raw) {
        var dk = toIsoDateKey(raw);
        if (dk) map[dk] = true;
      }
      (state.slotList || []).forEach(function (s) {
        if (!s) return;
        add(slotDateKeyIso(s));
      });
      Object.keys(state.daysWithEvents || {}).forEach(add);
      var evs = state.selectedVenue && state.selectedVenue.events;
      (evs || []).forEach(function (ev) {
        if (!ev) return;
        add(ev.date_key);
        add(ev.schema_start);
        add(ev.starts_at);
        add(ev.event_date);
        add(ev.start_date);
      });
      if (state.selectedVenue) add(state.selectedVenue.next_date_key);
      return Object.keys(map).sort();
    }

    function syncPopupDatetimePanel() {
      var panel = popupDatetimePanel();
      if (!panel) return;
      var show =
        state.branch === 'variants' &&
        state.flow === 'booking' &&
        !!state.selectedVenue &&
        !isStoreVenue(state.selectedVenue);
      if (show) {
        panel.hidden = false;
        panel.removeAttribute('hidden');
        if (!panel.__wbwCued) {
          panel.__wbwCued = true;
          panel.classList.remove('is-cue');
          void panel.offsetWidth;
          panel.classList.add('is-cue');
        }
      } else {
        panel.hidden = true;
        panel.setAttribute('hidden', '');
        panel.__wbwCued = false;
        panel.classList.remove('is-cue');
      }
    }

    function syncPopupSelectFilled(sel) {
      if (!sel) return;
      sel.classList.toggle('is-filled', !!String(sel.value || '').trim());
      syncPrettySelect(sel);
    }

    function prettySelectPortal() {
      var el = document.querySelector('[data-wbw-pretty-dd-portal]');
      if (el) return el;
      el = document.createElement('div');
      el.className = 'wbw-pretty-dd-portal';
      el.setAttribute('data-wbw-pretty-dd-portal', '');
      document.body.appendChild(el);
      return el;
    }

    function armPrettyDdClickShield() {
      state._wbwIgnoreZoomUntil = Date.now() + 500;
      if (document.querySelector('[data-wbw-pretty-dd-shield]')) return;
      var shield = document.createElement('div');
      shield.className = 'wbw-pretty-dd-shield';
      shield.setAttribute('data-wbw-pretty-dd-shield', '');
      document.body.appendChild(shield);
      function drop(ev) {
        if (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        }
        if (shield.parentNode) shield.parentNode.removeChild(shield);
        document.removeEventListener('click', drop, true);
        document.removeEventListener('pointerup', drop, true);
      }
      document.addEventListener('click', drop, true);
      document.addEventListener('pointerup', drop, true);
      window.setTimeout(drop, 500);
    }

    function closePrettySelects() {
      document.querySelectorAll('.wbw-pretty-dd.is-open').forEach(function (w) {
        w.classList.remove('is-open');
      });
      var portal = document.querySelector('[data-wbw-pretty-dd-portal]');
      if (portal) portal.innerHTML = '';
    }

    function syncPrettySelect(sel) {
      var wrap = sel && sel.closest('.wbw-pretty-dd');
      if (!wrap) return;
      var btn = wrap.querySelector('.wbw-pretty-dd__btn');
      if (!btn) return;
      var opt = sel.options[sel.selectedIndex];
      btn.textContent = opt ? opt.textContent : '';
      btn.classList.toggle('is-placeholder', !String(sel.value || '').trim());
      wrap.classList.toggle('is-filled', !!String(sel.value || '').trim());
    }

    function fillPrettySelectPanel(sel, panel) {
      if (!sel || !panel) return;
      panel.innerHTML = '';
      for (var i = 0; i < sel.options.length; i++) {
        var o = sel.options[i];
        var item = document.createElement('button');
        item.type = 'button';
        item.className =
          'wbw-pretty-dd__opt' +
          (o.value === sel.value ? ' is-selected' : '') +
          (o.disabled ? ' is-disabled' : '');
        item.textContent = o.textContent;
        if (o.disabled) item.disabled = true;
        (function (val, disabled) {
          function pick(ev) {
            if (ev) {
              ev.preventDefault();
              ev.stopPropagation();
              if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
            }
            if (disabled) return;
            armPrettyDdClickShield();
            sel.value = val;
            syncPrettySelect(sel);
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            closePrettySelects();
          }
          item.addEventListener('pointerdown', pick);
          item.addEventListener('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
          });
        })(o.value, !!o.disabled);
        panel.appendChild(item);
      }
    }

    function patchOpenPrettySelect(sel) {
      /* Never rebuild an open panel — that drops the option mid-tap. */
      syncPrettySelect(sel);
    }

    function openPrettySelect(sel) {
      var wrap = sel.closest('.wbw-pretty-dd');
      var btn = wrap && wrap.querySelector('.wbw-pretty-dd__btn');
      if (!wrap || !btn) return;
      var wasOpen = wrap.classList.contains('is-open');
      closePrettySelects();
      if (wasOpen) return;
      wrap.classList.add('is-open');
      var portal = prettySelectPortal();
      if (portal.parentNode) document.body.appendChild(portal);
      var panel = document.createElement('div');
      panel.className = 'wbw-pretty-dd__panel';
      fillPrettySelectPanel(sel, panel);
      var backdrop = document.createElement('div');
      backdrop.className = 'wbw-pretty-dd__backdrop';
      backdrop.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        armPrettyDdClickShield();
        closePrettySelects();
      });
      portal.appendChild(backdrop);
      portal.appendChild(panel);
      var rect = btn.getBoundingClientRect();
      var gap = 6;
      var spaceBelow = window.innerHeight - rect.bottom - gap;
      var inLb = !!(sel.closest && sel.closest('.wbw-lb'));
      var forceUp = inLb && isMobileViewport();
      var openUp = forceUp || (spaceBelow < 140 && rect.top > spaceBelow);
      var when = inLb && sel.closest('.wbw-lb__when');
      var whenRect = when ? when.getBoundingClientRect() : null;
      var width = whenRect
        ? Math.min(whenRect.width, window.innerWidth - 24)
        : rect.width;
      var left = whenRect ? whenRect.left : rect.left;
      if (left + width > window.innerWidth - 12) left = Math.max(12, window.innerWidth - 12 - width);
      if (left < 12) left = 12;
      if (inLb) panel.classList.add('wbw-pretty-dd__panel--lb');
      panel.style.position = 'fixed';
      panel.style.left = left + 'px';
      panel.style.width = width + 'px';
      panel.style.zIndex = '2147483647';
      panel.style.maxHeight = Math.min(260, Math.max(80, (openUp ? rect.top : spaceBelow) - 8)) + 'px';
      if (openUp) {
        panel.style.bottom = window.innerHeight - rect.top + gap + 'px';
        panel.style.top = 'auto';
      } else {
        panel.style.top = rect.bottom + gap + 'px';
        panel.style.bottom = 'auto';
      }
    }

    function enhancePopupSelect(sel) {
      if (!sel) return;
      if (sel.closest('.wbw-pretty-dd')) {
        syncPrettySelect(sel);
        return;
      }
      var wrap = document.createElement('div');
      wrap.className = 'wbw-pretty-dd';
      sel.parentNode.insertBefore(wrap, sel);
      wrap.appendChild(sel);
      sel.classList.add('wbw-pretty-dd__native');
      sel.setAttribute('tabindex', '-1');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wbw-pretty-dd__btn';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openPrettySelect(sel);
      });
      wrap.appendChild(btn);
      syncPrettySelect(sel);
      if (!document.__wbwPrettyDdDoc) {
        document.__wbwPrettyDdDoc = true;
        document.addEventListener('click', function (e) {
          if (e.target.closest('.wbw-pretty-dd, [data-wbw-pretty-dd-portal]')) return;
          document.querySelectorAll('.wbw-pretty-dd.is-open').forEach(function (w) {
            w.classList.remove('is-open');
          });
          var portal = document.querySelector('[data-wbw-pretty-dd-portal]');
          if (portal) portal.innerHTML = '';
        });
      }
    }

    function fillDateSelectOptions(sel, keys, preferredDate) {
      if (!sel) return '';
      var want = toIsoDateKey(preferredDate) || String(preferredDate || '').trim();
      var keep = want && keys.indexOf(want) >= 0 ? want : '';
      sel.disabled = false;
      sel.innerHTML = '';
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = 'Select a date';
      sel.appendChild(ph);
      keys.forEach(function (dk) {
        var opt = document.createElement('option');
        opt.value = dk;
        opt.textContent = formatPopupDateLabel(dk);
        sel.appendChild(opt);
      });
      sel.value = keep || '';
      if (keep && sel.value !== keep) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === keep) {
            sel.selectedIndex = i;
            break;
          }
        }
      }
      syncPrettySelect(sel);
      return sel.value || '';
    }

    function popupMonthPillsEl() {
      return wizardRoot.querySelector('[data-wbw-session-month-pills]');
    }
    function popupDatePillsEl() {
      return wizardRoot.querySelector('[data-wbw-session-date-pills]');
    }
    function popupTimePillsEl() {
      return wizardRoot.querySelector('[data-wbw-session-time-pills]');
    }

    function clearPillHost(host) {
      if (host) host.innerHTML = '';
    }

    function makeSessionPill(opts) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'wbw-popup-session__pill' +
        (opts.selected ? ' is-selected' : '') +
        (opts.disabled ? ' is-disabled' : '');
      btn.setAttribute('role', 'option');
      btn.setAttribute('aria-selected', opts.selected ? 'true' : 'false');
      btn.dataset.value = opts.value;
      btn.textContent = opts.label;
      if (opts.disabled) btn.disabled = true;
      return btn;
    }

    function refreshPopupSessionPills(opts) {
      opts = opts || {};
      var apply = opts.apply !== false;
      var allDates = uniquePopupDateKeys();
      var months = uniquePopupMonthKeys(allDates);
      var monthHost = popupMonthPillsEl();
      var dateHost = popupDatePillsEl();
      var timeHost = popupTimePillsEl();
      if (!monthHost || !dateHost || !timeHost) return;

      var month = pickFirst(
        months,
        opts.preferredMonth || state.selectedPopupMonth || ymKeyFromDateKey(opts.preferredDate) || ''
      );
      state.selectedPopupMonth = month;

      clearPillHost(monthHost);
      months.forEach(function (ym) {
        monthHost.appendChild(
          makeSessionPill({
            value: ym,
            label: formatPopupMonthLabel(ym),
            selected: ym === month,
          })
        );
      });

      var dates = month ? dateKeysForMonth(allDates, month) : [];
      var dateKey = pickFirst(
        dates,
        opts.preferredDate != null ? opts.preferredDate : state.selectedDate || ''
      );
      state.selectedDate = dateKey;

      clearPillHost(dateHost);
      dates.forEach(function (dk) {
        dateHost.appendChild(
          makeSessionPill({
            value: dk,
            label: formatPopupSessionDateLabel(dk),
            selected: dk === dateKey,
          })
        );
      });

      var daySlots = dateKey
        ? slotsForDate(dateKey).filter(function (s) {
            return s && !slotHidden(s);
          })
        : [];
      var preferredGid = String(
        opts.preferredGid != null
          ? opts.preferredGid
          : state.selectedSlot
            ? slotSyncKey(state.selectedSlot)
            : ''
      );
      var bookableKeys = daySlots.filter(slotBookable).map(slotSyncKey);
      var allKeys = daySlots.map(slotSyncKey);
      var gid = pickFirst(bookableKeys.length ? bookableKeys : allKeys, preferredGid);

      clearPillHost(timeHost);
      daySlots.forEach(function (slot) {
        var key = slotSyncKey(slot);
        timeHost.appendChild(
          makeSessionPill({
            value: key,
            label: formatPopupSessionTimeLabel(slot),
            selected: key === gid,
            disabled: !slotBookable(slot),
          })
        );
      });

      if (apply) applyPopupSlotFromPills(dateKey, gid);
      else if (dateKey && gid) {
        var slotKeep = findSlotForTimeValue(gid);
        state.selectedSlot = slotKeep || null;
      } else if (!gid) {
        state.selectedSlot = null;
      }
      syncPopupDatetimePanel();
      syncAllSessionPillNav();
    }

    function syncSessionPillNav(host) {
      if (!host) return;
      var clip = host.closest('.wbw-popup-session__pills-clip') || host.parentElement;
      if (!clip) return;
      var prev = clip.querySelector('[data-wbw-session-prev]');
      var next = clip.querySelector('[data-wbw-session-next]');

      function layoutGhost() {
        var pillCount = host.querySelectorAll('.wbw-popup-session__pill').length;
        var max = Math.max(0, host.scrollWidth - host.clientWidth);
        var row = host.closest('[data-wbw-session-row]');
        var rowKind = row && row.getAttribute('data-wbw-session-row');
        var overflowAt = rowKind === 'date' ? 2 : 3;
        var show = pillCount > overflowAt || max > 1;
        host.__wbwSessionNavShow = show;
        if (prev) {
          prev.hidden = !show;
          prev.removeAttribute('disabled');
        }
        if (next) {
          next.hidden = !show;
          next.removeAttribute('disabled');
        }
        updateGhostEdges();
      }

      function updateGhostEdges() {
        if (!host.__wbwSessionNavShow) return;
        var max = Math.max(0, host.scrollWidth - host.clientWidth);
        var left = host.scrollLeft || 0;
        if (prev) {
          if (left > 2) prev.classList.remove('is-ghost-dim');
          else prev.classList.add('is-ghost-dim');
        }
        if (next) {
          if (left < max - 2) next.classList.remove('is-ghost-dim');
          else next.classList.add('is-ghost-dim');
        }
      }

      layoutGhost();
      if (!host.__wbwSessionNavBound) {
        host.__wbwSessionNavBound = true;
        host.addEventListener('scroll', updateGhostEdges, { passive: true });
      }
    }

    function syncAllSessionPillNav() {
      function run() {
        syncSessionPillNav(popupMonthPillsEl());
        syncSessionPillNav(popupDatePillsEl());
        syncSessionPillNav(popupTimePillsEl());
      }
      run();
      window.requestAnimationFrame(function () {
        run();
        window.requestAnimationFrame(run);
      });
    }

    function usePopupSessionPills() {
      /* SS2 month/date/time pills on all viewports for popup venues */
      return true;
    }

    function fillPopupDateSelect(preferredDate) {
      if (usePopupSessionPills()) {
        refreshPopupDatetimeControls({
          preferredDate: preferredDate,
          preferredGid: state.selectedSlot ? slotSyncKey(state.selectedSlot) : '',
          apply: false,
        });
        return;
      }
      var sel = popupDateSelect();
      if (!sel) return;
      var keys = uniquePopupDateKeys();
      fillDateSelectOptions(sel, keys, preferredDate);
      syncPopupSelectFilled(sel);
    }

    function fillPopupTimeSelect(dateKey, preferredGid) {
      if (usePopupSessionPills()) {
        refreshPopupDatetimeControls({
          preferredDate: dateKey || state.selectedDate,
          preferredGid: preferredGid || '',
          apply: false,
        });
        return;
      }
      var sel = popupTimeSelect();
      if (!sel) return;
      sel.innerHTML = '<option value="">Select a time</option>';
      if (!dateKey) {
        sel.value = '';
        sel.disabled = false;
        syncPopupSelectFilled(sel);
        return;
      }
      var daySlots = slotsForDate(dateKey).filter(function (s) {
        return s && !slotHidden(s);
      });
      if (!daySlots.length) {
        sel.innerHTML = '<option value="">No sessions this day</option>';
        sel.value = '';
        sel.disabled = false;
        syncPopupSelectFilled(sel);
        return;
      }
      daySlots.forEach(function (slot) {
        var opt = document.createElement('option');
        opt.value = slotSyncKey(slot);
        opt.textContent = formatSlotOptionText(slot);
        opt.disabled = !slotBookable(slot);
        sel.appendChild(opt);
      });
      var keep =
        preferredGid &&
        daySlots.some(function (s) {
          return slotSyncKey(s) === String(preferredGid);
        })
          ? String(preferredGid)
          : '';
      sel.disabled = false;
      sel.value = keep || '';
      syncPopupSelectFilled(sel);
    }

    function clampVariantQtyToCapacity() {
      var max = maxBookableQty();
      if (!(max >= 0)) return false;
      var total = 0;
      Object.keys(state.variantQty).forEach(function (k) {
        if (isAddonVariantId(k)) return;
        total += state.variantQty[k] || 0;
      });
      if (total <= max) return false;
      var keys = Object.keys(state.variantQty).filter(function (k) {
        return !isAddonVariantId(k) && (state.variantQty[k] || 0) > 0;
      });
      var over = total - max;
      for (var i = keys.length - 1; i >= 0 && over > 0; i--) {
        var id = keys[i];
        var q = state.variantQty[id] || 0;
        var cut = Math.min(q, over);
        var next = q - cut;
        if (next <= 0) delete state.variantQty[id];
        else state.variantQty[id] = next;
        over -= cut;
      }
      if (max > 0) {
        showWizardNotice(max === 1 ? 'Only 1 seat left' : 'Only ' + max + ' seats left');
      }
      return true;
    }

    function applyPopupSlotFromSelects() {
      if (usePopupSessionPills()) {
        applyPopupSlotFromPills(
          state.selectedDate,
          state.selectedSlot ? slotSyncKey(state.selectedSlot) : ''
        );
        return;
      }
      var dateSel = popupDateSelect();
      var timeSel = popupTimeSelect();
      var dateKey = dateSel ? String(dateSel.value || '').trim() : '';
      var gid = timeSel ? String(timeSel.value || '').trim() : '';
      applyPopupSlotFromPills(dateKey, gid);
    }

    function applyPopupSlotFromPills(dateKey, gid) {
      dateKey = toIsoDateKey(dateKey) || String(dateKey || '').trim();
      gid = String(gid || '').trim();
      state.selectedDate = dateKey;
      if (dateKey) {
        state.selectedPopupMonth = ymKeyFromDateKey(dateKey) || state.selectedPopupMonth || '';
      }
      if (!dateKey || !gid) {
        state.selectedSlot = null;
        syncVariantsAfterSlotChange();
        clearBookingUrlEventIdKeepVariant();
        return;
      }
      var slot = findSlotForTimeValue(gid);
      if (!slot) {
        state.selectedSlot = null;
        syncVariantsAfterSlotChange();
        clearBookingUrlEventIdKeepVariant();
        return;
      }
      state.selectedSlot = slot;
      if (!slotBookable(slot)) {
        clampVariantQtyToCapacity();
        updateVariantStepUi();
        syncCapacityRing();
        return;
      }
      if (typeof S.clearWizardNotice === 'function') S.clearWizardNotice();
      clampVariantQtyToCapacity();
      ensureLockedVariantFromUrlOrSlot();
      window.__WB_LOCK_VARIANT_URL__ = true;
      syncWorkshopSelection(slot);
      syncBookingUrlForDatetimeStep(slot);
      stampFocusedVariantWhenFromMain();
      syncVariantsAfterSlotChange();
      syncCapacityRing();
      syncSiblingWorkshopPromo();
    }

    function patchPopupDatetimeOptionsInPlace(dateKey, preferredGid) {
      if (usePopupSessionPills()) {
        var before = state.selectedSlot ? slotSyncKey(state.selectedSlot) : '';
        refreshPopupSessionPills({
          preferredMonth: state.selectedPopupMonth,
          preferredDate: dateKey || state.selectedDate,
          preferredGid: preferredGid || before,
          apply: false,
        });
        var after = state.selectedSlot ? slotSyncKey(state.selectedSlot) : '';
        return { gidGone: !!(before && !after) };
      }
      var timeSel = popupTimeSelect();
      var gidGone = false;
      var dateSel = popupDateSelect();
      if (dateSel) {
        syncPopupSelectFilled(dateSel);
        patchOpenPrettySelect(dateSel);
      }
      if (!timeSel) return { gidGone: false };
      if (!dateKey) {
        syncPopupSelectFilled(timeSel);
        patchOpenPrettySelect(timeSel);
        return { gidGone: false };
      }
      var daySlots = slotsForDate(dateKey).filter(function (s) {
        return s && !slotHidden(s);
      });
      var byKey = Object.create(null);
      daySlots.forEach(function (s) {
        byKey[slotSyncKey(s)] = s;
      });
      var current = String(timeSel.value || preferredGid || '').trim();
      var still = false;
      Array.prototype.slice.call(timeSel.options).forEach(function (opt) {
        if (!opt.value) return;
        var slot = byKey[opt.value];
        if (!slot) {
          if (opt.parentNode) opt.parentNode.removeChild(opt);
          return;
        }
        opt.textContent = formatSlotOptionText(slot);
        opt.disabled = !slotBookable(slot);
        if (opt.value === current) still = true;
        delete byKey[opt.value];
      });
      Object.keys(byKey).forEach(function (k) {
        var slot = byKey[k];
        var opt = document.createElement('option');
        opt.value = k;
        opt.textContent = formatSlotOptionText(slot);
        opt.disabled = !slotBookable(slot);
        timeSel.appendChild(opt);
      });
      if (current && !still) {
        timeSel.value = '';
        gidGone = true;
      } else if (current) {
        timeSel.value = current;
      }
      syncPopupSelectFilled(timeSel);
      patchOpenPrettySelect(timeSel);
      return { gidGone: gidGone };
    }

    function patchPopupDateSelectInPlace(preferredDate) {
      if (usePopupSessionPills()) {
        refreshPopupSessionPills({
          preferredMonth: state.selectedPopupMonth,
          preferredDate: preferredDate || state.selectedDate,
          preferredGid: state.selectedSlot ? slotSyncKey(state.selectedSlot) : '',
          apply: false,
        });
        return;
      }
      var sel = popupDateSelect();
      if (!sel) return;
      var keys = uniquePopupDateKeys();
      var have = Object.create(null);
      Array.prototype.slice.call(sel.options).forEach(function (opt) {
        if (!opt.value) return;
        if (keys.indexOf(opt.value) === -1) {
          if (opt.parentNode) opt.parentNode.removeChild(opt);
          return;
        }
        have[opt.value] = true;
      });
      keys.forEach(function (k) {
        if (have[k]) return;
        var opt = document.createElement('option');
        opt.value = k;
        opt.textContent = formatPopupDateLabel(k);
        sel.appendChild(opt);
      });
      var want = toIsoDateKey(preferredDate) || String(preferredDate || '').trim();
      if (want && keys.indexOf(want) !== -1) sel.value = want;
      else if (sel.value && keys.indexOf(sel.value) === -1) sel.value = '';
      syncPopupSelectFilled(sel);
      patchOpenPrettySelect(sel);
    }

    function applyPopupLiveRefresh(flags) {
      flags = flags || {};
      var preferredDate = state.selectedDate;
      var preferredGid = state.selectedSlot ? slotSyncKey(state.selectedSlot) : '';
      if (!usePopupSessionPills() && (flags.daysChanged || flags.structureChanged)) {
        patchPopupDateSelectInPlace(preferredDate);
      }
      var patch = patchPopupDatetimeOptionsInPlace(preferredDate, preferredGid);
      if (patch.gidGone) {
        state.selectedSlot = null;
        var timeSel = popupTimeSelect();
        if (timeSel) timeSel.value = '';
        clearBookingUrlEventIdKeepVariant();
      }
      clampVariantQtyToCapacity();
      updateVariantStepUi();
    }

    function hydrateVariantsDatetimeControls() {
      if (state.branch !== 'variants' || !state.selectedVenue) return;
      if (isStoreVenue(state.selectedVenue)) return;
      bindPopupDatetimeControls();
      refreshPopupDatetimeControls({
        preferredDate: state.selectedDate,
        preferredGid: state.selectedSlot ? slotSyncKey(state.selectedSlot) : '',
        apply: false,
      });
    }

    function refreshPopupDatetimeControls(opts) {
      opts = opts || {};
      if (usePopupSessionPills()) {
        refreshPopupSessionPills({
          preferredMonth: opts.preferredMonth || '',
          preferredDate: opts.preferredDate != null ? opts.preferredDate : state.selectedDate,
          preferredGid:
            opts.preferredGid != null
              ? opts.preferredGid
              : state.selectedSlot
                ? slotSyncKey(state.selectedSlot)
                : '',
          apply: opts.apply,
        });
        return;
      }
      fillPopupDateSelect(opts.preferredDate != null ? opts.preferredDate : state.selectedDate);
      var dateSel = popupDateSelect();
      var dateKey = dateSel ? String(dateSel.value || '').trim() : '';
      fillPopupTimeSelect(
        dateKey,
        opts.preferredGid != null
          ? opts.preferredGid
          : state.selectedSlot
            ? slotSyncKey(state.selectedSlot)
            : ''
      );
      if (opts.apply !== false) applyPopupSlotFromSelects();
      syncPopupDatetimePanel();
      if (opts.apply === false) {
        patchOpenPrettySelect(popupDateSelect());
        patchOpenPrettySelect(popupTimeSelect());
      }
    }

    function bindPopupDatetimeControls() {
      bindPopupSessionPills();
      var dateSel = popupDateSelect();
      var timeSel = popupTimeSelect();
      if (dateSel && !dateSel.__wbwBound) {
        dateSel.__wbwBound = true;
        dateSel.addEventListener('change', function () {
          if (liveFlags.syncingWhen) return;
          if (usePopupSessionPills()) return;
          clearWizardNotice();
          state.selectedDate = String(dateSel.value || '').trim();
          state.selectedSlot = null;
          syncPopupSelectFilled(dateSel);
          fillPopupTimeSelect(state.selectedDate, '');
          applyPopupSlotFromSelects();
          stampFocusedVariantWhenFromMain();
          refreshOpenLightboxWhen();
          refreshLiveNow({ force: true });
        });
      }
      if (timeSel && !timeSel.__wbwBound) {
        timeSel.__wbwBound = true;
        timeSel.addEventListener('change', function () {
          if (liveFlags.syncingWhen) return;
          if (usePopupSessionPills()) return;
          clearWizardNotice();
          syncPopupSelectFilled(timeSel);
          applyPopupSlotFromSelects();
          stampFocusedVariantWhenFromMain();
          refreshOpenLightboxWhen();
          refreshLiveNow({ force: true });
        });
      }
      enhancePopupSelect(dateSel);
      enhancePopupSelect(timeSel);
    }

    function bindPopupSessionPills() {
      var panel = popupDatetimePanel();
      if (!panel || panel.__wbwSessionBound) return;
      panel.__wbwSessionBound = true;
      panel.addEventListener('click', function (ev) {
        var pill = ev.target && ev.target.closest && ev.target.closest('.wbw-popup-session__pill');
        if (!pill || pill.disabled) return;
        var row = pill.closest('[data-wbw-session-row]');
        var kind = row && row.getAttribute('data-wbw-session-row');
        var val = pill.dataset.value || '';
        if (liveFlags.syncingWhen) return;
        clearWizardNotice();
        if (kind === 'month') {
          state.selectedPopupMonth = val;
          var y = Number(val.slice(0, 4));
          var m = Number(val.slice(5, 7));
          if (Number.isFinite(y) && Number.isFinite(m)) {
            state.viewMonth = new Date(y, m - 1, 1);
          }
          setPopupDatetimeLoading(true);
          var ensure =
            bookingRoot && typeof bookingRoot.__wbEnsureVenueCalendarMonths === 'function'
              ? bookingRoot.__wbEnsureVenueCalendarMonths(state.selectedVenue, y, m, {
                  lookahead: 1,
                  prefetch: true,
                })
              : Promise.resolve();
          Promise.resolve(ensure)
            .then(function () {
              rebindSelectedVenueCard();
              state.slotList = eventsToSlots((state.selectedVenue && state.selectedVenue.events) || []);
              state.daysWithEvents = buildDaysMap(state.slotList);
              setPopupDatetimeLoading(false);
              refreshPopupSessionPills({
                preferredMonth: val,
                preferredDate: '',
                preferredGid: '',
                apply: true,
              });
              stampFocusedVariantWhenFromMain();
              refreshOpenLightboxWhen();
              refreshLiveNow({ force: true });
              try {
                var wbwM = global.WorkshopBookingWizardAnalytics;
                if (wbwM && typeof wbwM.trackUser === 'function') {
                  wbwM.trackUser('date', 'wbw_month_select', state, wizardRoot, S.data || {}, {
                    wbw_source: 'popup_month',
                  });
                }
              } catch (_) {}
            })
            .catch(function () {
              setPopupDatetimeLoading(false);
            });
          return;
        }
        if (kind === 'date') {
          refreshPopupSessionPills({
            preferredMonth: state.selectedPopupMonth,
            preferredDate: val,
            preferredGid: '',
            apply: true,
          });
          stampFocusedVariantWhenFromMain();
          refreshOpenLightboxWhen();
          refreshLiveNow({ force: true });
          try {
            var wbwA = global.WorkshopBookingWizardAnalytics;
            if (wbwA && typeof wbwA.trackUser === 'function') {
              wbwA.trackUser('date', 'wbw_date_select', state, wizardRoot, S.data || {}, {
                wbw_source: 'popup_date',
              });
            }
          } catch (_) {}
          return;
        }
        if (kind === 'time') {
          refreshPopupSessionPills({
            preferredMonth: state.selectedPopupMonth,
            preferredDate: state.selectedDate,
            preferredGid: val,
            apply: true,
          });
          stampFocusedVariantWhenFromMain();
          refreshOpenLightboxWhen();
          refreshLiveNow({ force: true });
          try {
            var wbwT = global.WorkshopBookingWizardAnalytics;
            if (wbwT && typeof wbwT.trackUser === 'function') {
              wbwT.trackUser('time', 'wbw_time_select', state, wizardRoot, S.data || {}, {
                wbw_source: 'popup_time',
              });
            }
          } catch (_) {}
        }
      });
    }

    function startPopupBookingStep() {
      rebindSelectedVenueCard();
      if (!state.selectedVenue) return Promise.resolve();
      if (!bookingRoot || typeof bookingRoot.__wbEnsureVenueCalendar !== 'function') {
        return Promise.reject(new Error('venue calendar fetch unavailable'));
      }
      if (!state.selectedVenue.venue_ref_id) {
        return Promise.reject(new Error('venue_ref_id missing'));
      }
      if (state.selectedVenue.has_events !== true) {
        return Promise.reject(new Error('venue has_events is not true'));
      }
      if (bookingRoot) bookingRoot.__wbWizardVenueChosen = true;
      wizardRoot.__wbwUrlDeepLinkComplete = true;
      wizardRoot.__wbwUserReachedDatetime = true;
      state._wbCalLoadSeq = (state._wbCalLoadSeq || 0) + 1;
      var loadSeq = state._wbCalLoadSeq;
      var viewSeed = state.viewMonth instanceof Date ? state.viewMonth : new Date();
      if (
        state.selectedVenue.next_date_key &&
        /^\d{4}-\d{2}/.test(String(state.selectedVenue.next_date_key))
      ) {
        var nd = String(state.selectedVenue.next_date_key);
        viewSeed = new Date(Number(nd.slice(0, 4)), Number(nd.slice(5, 7)) - 1, 1);
      }
      state.viewMonth = viewSeed;
      state.flow = 'booking';
      wizardRoot.setAttribute('data-wbw-flow', 'booking');
      var savedPopupSession = peekVenueSession(state.selectedVenue);
      if (savedPopupSession && savedPopupSession.viewMonth) {
        state.viewMonth = new Date(savedPopupSession.viewMonth);
      }
      state._wbwUserPickedCalDate = !!(savedPopupSession && savedPopupSession.userPickedCalDate);
      state.selectedDate = savedPopupSession ? String(savedPopupSession.selectedDate || '') : '';
      state.selectedSlot = null;
      state.variantQty = savedPopupSession ? clonePlainMap(savedPopupSession.variantQty) : {};
      state.variantWhen = savedPopupSession ? clonePlainMap(savedPopupSession.variantWhen) : {};
      if (savedPopupSession && savedPopupSession.focusedVariantId) {
        state.focusedVariantId = savedPopupSession.focusedVariantId;
      }
      if (savedPopupSession && savedPopupSession.lockedVariantId) {
        state.lockedVariantId = savedPopupSession.lockedVariantId;
      }
      state.lbEditVariant = '';
      state.lbApplyAll = null;
      state.lbAskApply = false;
      if (!savedPopupSession || !savedPopupSession.selectedDate) resetDatetimeControlsDom();
      updateBranchTitles();
      syncBookingUrlForVenueStep(state.selectedVenue);
      syncVenueKindAttr();
      setBranch('variants');
      bindPopupDatetimeControls();
      setPopupDatetimeHint('');
      setPopupDatetimeLoading(true);

      function stillOnPopupIntent() {
        return (
          loadSeq === state._wbCalLoadSeq &&
          state.branch === 'variants' &&
          state.selectedVenue &&
          !isStoreVenue(state.selectedVenue)
        );
      }

      var hasLocal =
        Array.isArray(state.selectedVenue.events) && state.selectedVenue.events.length > 0;
      if (hasLocal) {
        state.slotList = eventsToSlots(state.selectedVenue.events || []);
        state.daysWithEvents = buildDaysMap(state.slotList);
      } else {
        state.slotList = [];
        state.daysWithEvents = {};
      }
      refreshPopupDatetimeControls({
        preferredDate: savedPopupSession ? savedPopupSession.selectedDate || '' : '',
        preferredGid: savedPopupSession
          ? savedPopupSession.slotSyncKey || savedPopupSession.slotGid || ''
          : '',
        apply: false,
      });
      renderVariants();
      updateVariantStepUi();

      /* Hub popup venue: one full horizon fetch so later months (e.g. Dec) appear in Month pills.
         Store shop calendar keeps month lookahead via __wbEnsureVenueCalendar. */
      var loadPopupEvents =
        typeof bookingRoot.__wbEnsurePopupVenueCalendarAll === 'function'
          ? bookingRoot.__wbEnsurePopupVenueCalendarAll(state.selectedVenue, {
              abortPrevious: false,
            })
          : bookingRoot.__wbEnsureVenueCalendar(state.selectedVenue, state.viewMonth, {
              lookahead: 6,
              prefetch: false,
              abortPrevious: false,
            });

      return loadPopupEvents
        .then(function () {
          if (!stillOnPopupIntent()) return;
          rebindSelectedVenueCard();
          if (!state.selectedVenue) return;
          var baseSlots = eventsToSlots(state.selectedVenue.events || []);
          state.slotList = baseSlots;
          state.daysWithEvents = buildDaysMap(state.slotList);
          syncSelectedVenueEventsFromSlots(state.slotList);
          applySavedVenueSession(savedPopupSession);
          setPopupDatetimeLoading(false);
          setPopupDatetimeHint('');
          refreshPopupDatetimeControls({
            preferredDate: state.selectedDate || '',
            preferredGid: state.selectedSlot
              ? slotSyncKey(state.selectedSlot)
              : savedPopupSession
                ? savedPopupSession.slotSyncKey || savedPopupSession.slotGid || ''
                : '',
            apply: usePopupSessionPills() ? true : !!state.selectedDate,
          });
          renderVariants();
          updateVariantStepUi();
          ensureLivePoll();
          if (!baseSlots.length) return state.slotList;
          state._wbLiveSince = '';
          sweepViewMonthLive();
          return quietEnrichCurrentSlots(stillOnPopupIntent, { force: true });
        })
        .catch(function (err) {
          if (!stillOnPopupIntent()) return;
          setPopupDatetimeLoading(false);
          if (err && err.name === 'AbortError') return;
          setPopupDatetimeHint(
            err && err.message === 'bad_request'
              ? 'Invalid date range. Try again.'
              : "Couldn't load dates. Try again.",
            true
          );
        });
    }

      S.isCalTimeDdOpen = isCalTimeDdOpen;
      S.softRefreshDatetimeDayButtons = softRefreshDatetimeDayButtons;
      S.syncCalTimeDdButtonLabel = syncCalTimeDdButtonLabel;
      S.softRefreshDatetimeTimeUi = softRefreshDatetimeTimeUi;
      S.applySlotToDatetimeStep = applySlotToDatetimeStep;
      S.clearCalLoadingTimer = clearCalLoadingTimer;
      S.paintCalLoadingOverlay = paintCalLoadingOverlay;
      S.setDatetimeCalLoading = setDatetimeCalLoading;
      S.prefetchVenueCalendar = prefetchVenueCalendar;
      S.calendarGridMatchesViewMonth = calendarGridMatchesViewMonth;
      S.paintSlotsOntoCalendar = paintSlotsOntoCalendar;
      S.resetDatetimeControlsDom = resetDatetimeControlsDom;
      S.slotsForDate = slotsForDate;
      S.applyDatetimeSelectionAfterSlots = applyDatetimeSelectionAfterSlots;
      S.renderCalendar = renderCalendar;
      S.syncCalMonthNavLabels = syncCalMonthNavLabels;
      S.syncDatetimeHasDate = syncDatetimeHasDate;
      S.loadCalendarMonthForView = loadCalendarMonthForView;
      S.closeCalTimeDd = closeCalTimeDd;
      S.openCalTimeDd = openCalTimeDd;
      S.syncCalTimeAwaitingCue = syncCalTimeAwaitingCue;
      S.syncCalTimeDdFromSelect = syncCalTimeDdFromSelect;
      S.findSlotForTimeValue = findSlotForTimeValue;
      S.onTimeSelectChange = onTimeSelectChange;
      S.patchCalTimeNativeSelect = patchCalTimeNativeSelect;
      S.bindCalTimeDdOpt = bindCalTimeDdOpt;
      S.patchCalTimeDdPanelInPlace = patchCalTimeDdPanelInPlace;
      S.renderCalTimeNativeSelect = renderCalTimeNativeSelect;
      S.renderTimeOptions = renderTimeOptions;
      S.bindCalTimeControls = bindCalTimeControls;
      S.shiftCalendarMonth = shiftCalendarMonth;
      S.bindCalMonthSwipe = bindCalMonthSwipe;
      S.syncWorkshopSelection = syncWorkshopSelection;
      S.startDatetimeStep = startDatetimeStep;
      S.popupDateSelect = popupDateSelect;
      S.popupTimeSelect = popupTimeSelect;
      S.popupDatetimePanel = popupDatetimePanel;
      S.setPopupDatetimeHint = setPopupDatetimeHint;
      S.setPopupDatetimeLoading = setPopupDatetimeLoading;
      S.slotDateKeyIso = slotDateKeyIso;
      S.uniquePopupDateKeys = uniquePopupDateKeys;
      S.syncPopupDatetimePanel = syncPopupDatetimePanel;
      S.syncPopupSelectFilled = syncPopupSelectFilled;
      S.prettySelectPortal = prettySelectPortal;
      S.armPrettyDdClickShield = armPrettyDdClickShield;
      S.closePrettySelects = closePrettySelects;
      S.syncPrettySelect = syncPrettySelect;
      S.fillPrettySelectPanel = fillPrettySelectPanel;
      S.patchOpenPrettySelect = patchOpenPrettySelect;
      S.openPrettySelect = openPrettySelect;
      S.enhancePopupSelect = enhancePopupSelect;
      S.fillDateSelectOptions = fillDateSelectOptions;
      S.fillPopupDateSelect = fillPopupDateSelect;
      S.fillPopupTimeSelect = fillPopupTimeSelect;
      S.clampVariantQtyToCapacity = clampVariantQtyToCapacity;
      S.applyPopupSlotFromSelects = applyPopupSlotFromSelects;
      S.applyPopupSlotFromPills = applyPopupSlotFromPills;
      S.refreshPopupSessionPills = refreshPopupSessionPills;
      S.bindPopupSessionPills = bindPopupSessionPills;
      S.patchPopupDatetimeOptionsInPlace = patchPopupDatetimeOptionsInPlace;
      S.patchPopupDateSelectInPlace = patchPopupDateSelectInPlace;
      S.applyPopupLiveRefresh = applyPopupLiveRefresh;
      S.hydrateVariantsDatetimeControls = hydrateVariantsDatetimeControls;
      S.refreshPopupDatetimeControls = refreshPopupDatetimeControls;
      S.bindPopupDatetimeControls = bindPopupDatetimeControls;
      S.startPopupBookingStep = startPopupBookingStep;
    }
  };
})(typeof window !== "undefined" ? window : this);
